<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import FormSaveButton from '../../../../app/components/form/SaveButton.vue'
  import FormCancelButton from '../../../../app/components/form/CancelButton.vue'
  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import {clone} from 'lodash'
  import {required} from 'vuelidate/lib/validators'

  export default {
    components: {ListHeader, FormSaveButton, FormCancelButton},
    data () {
      return {
        isEdit: false,
        isSubmitted: false,
        isLoadingData: true,
        form: {
          name: '',
          nationality: ''
        },
        dependencies: {}
      }
    },
    validations: {
      form: {
        name: {required},
        nationality: {required}
      }
    },
    mounted () {
      const id = this.$route.params.id || null
      if (id) {
        this.isEdit = true
        restfulService.get('knowledge_area', null, id)
          .then(response => {
            this.form = response
            this.isLoadingData = false
          })
          .catch(e => {
            console.log(e)
            this.isLoadingData = false
          })
      } else {
        this.isLoadingData = false
      }
    },
    methods: {
      onSend () {
        this.isSubmitted = true
        const data = clone(this.form)
        restfulService.save('knowledge_area', null, null, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.$router.push({name: 'knowledge_area.index'})
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">

        <ListHeader title="Área de Conhecimento (CNPq)"/>

        <el-card class="el-card__save_form box-card">
            <div slot="header">
                <span>Dados da Área de Conhecimento (CNPq)</span>
            </div>
            <el-form ref="form"
                     :model="form"
                     label-width="20%"
                     v-on:submit.prevent="onSend">
                <el-form-item label="Nome"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.name.$error }">
                    <el-input v-model="form.name"
                              @input="$v.form.name.$touch()"></el-input>
                    <div class="el-form-item__error" v-if="$v.form.name.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item label="Nacionalidade"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.nationality.$error }">
                    <el-input v-model="form.nationality"
                              @input="$v.form.nationality.$touch()"></el-input>
                    <div class="el-form-item__error" v-if="$v.form.nationality.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item>
                    <form-save-button :event-click="onSend"
                                      :is-disabled="isSubmitted || $v.$invalid"
                                      :is-submitted="isSubmitted">
                    </form-save-button>
                    <form-cancel-button route-name="knowledge_area.index"/>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>



// WEBPACK FOOTER //
// Form.vue?99fc3e16